module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAQCAYAAADESFVDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALdJREFUeNpiUFRUNGAgAJiAWACocD4+RYwgAqhoP5D6AMSJ9+/f/4DNJBBoBOIAIN4P1CCArogZRHz48OGBoKCgAFShB5C9Eij2A90kmGkXgNgA3US4IqhbEqFugyk0gDscGUAlQB4RgHmGEZuXoQrPY3MTMshHYh9gwmIKKGAToNwFQLc6MqEp6EdSUAhUkIjicKACkCQsekAhvwA9WhSQHOoIVHABW7T041IA9y4Qv8eXZAACDAA6dDudiPoccgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/exercise-3/cinetics-line/next-active.png
// module id = 267
// module chunks = 0